// eslint-disable-next-line @typescript-eslint/no-unused-vars
const setCrashlyticsUserId = (_: string | number) => {};
export default setCrashlyticsUserId;
